export default __webpack_public_path__ + "static/media/hydrophobic_fleece.0828e1e1.jpg";